export enum CommissionPaymentMethodType {
  Cash = "Cash",
  Check = "Check",
  CreditCard = "CreditCard",
  BankTransfer = "BankTransfer"
}
